import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cart';
import classroomReducer from './classroom';
import errorReducer from './error';
import userReducer from './user';

export const store = configureStore({
    reducer: {
        cart: cartReducer,
        classroom: classroomReducer,
        error: errorReducer,
        user: userReducer
    }
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;